import { apiConfig } from '../api-config';

export const getContestationbyID = async (TokenKey: string, cdTerritory: string) => apiConfig
  .get(`api/Contestation/get-contestation-by-id?tokenKey=${TokenKey}&cdTerritory=${cdTerritory}`)
  .then((resp) => resp.data)
  .catch((err) => ({ hasErrors: true, objectResult: [], err }));
